module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAA8klEQVQ4jc2Rv2oCQRCHvxMJRGwk6U3lK8hhaWNhFfARFB/FJu0VduIDmCqgjY3gG4iBpA3igV2ClRNO9+RY5/6JhT8Y2B2Gj91vuHlExK6GiLyLiG9qIiKuPXcRa6Aj8XnVQE54iDSfAT/lx0/A7ghwToiCMuRm0Fa3GxroJwMofsZyNEtw9JFHdlCeAvHitqbJDlIDNsAjUDW9L+DP3D/PgATZAzO4BfpACXgAeqa3Bt7SHA0T3NgZxTlq5YCEaWugxRWgpSZbeWd6HGM7Knt1BWeuvShYdRdoAi9ABSgDReAA7IFfs7lvYAqMw/XfWYB/vDGEUyDR9DkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/X3.png
// module id = rsCj
// module chunks = 42